import { useState } from 'react';
import { KENKYU_SHUBETSU, KENKYU_MOKEI } from '../shared/constants';

export default function PersonForm({ person, onChange, personId, onLoad }) {
  const [saving, setSaving] = useState(false);
  const inp = (label, key, type = "text", placeholder = "", readOnly = false) => (
    <div className="field">
      <label className="field-label">
        {label}
        {readOnly && <span className="badge-db">DB</span>}
      </label>
      <input
        className={`field-input${readOnly ? " readonly" : ""}`}
        type={type} value={person[key] || ""}
        onChange={e => onChange(key, e.target.value)}
        placeholder={placeholder}
        readOnly={readOnly}
      />
    </div>
  );

  return (
    <div className="card">
      <h2 className="section-title">従事者情報</h2>
      <p className="help-text">
        <span className="badge-db">DB</span> マークの項目は将来SQLから自動取得されます。現在はサンプルデータを表示しています。
      </p>

      <div className="db-select-row">
        <label className="field-label">従事者ID（将来:DBから検索）</label>
        <div style={{ display: "flex", gap: 8 }}>
          <input className="field-input" value={personId} readOnly style={{ width: 120 }} />
          <button className="btn" onClick={() => onLoad("P001")}>サンプル読込</button>
          <button
            className="btn btn-primary"
            onClick={async () => {
              setSaving(true);
              try {
                const body = { id: personId || person.id, ...person };
                const res = await fetch('/api/person', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(body)
                });
                if (!res.ok) throw new Error(await res.text());
                alert('保存しました');
              } catch (e) {
                console.error(e);
                alert('保存に失敗しました');
              } finally {
                setSaving(false);
              }
            }}
            disabled={saving}
          >
            {saving ? '保存中…' : 'DBに保存'}
          </button>
        </div>
      </div>

      <h3 className="subsection-title">基本情報（DBから取得）</h3>
      <div className="form-grid">
        {inp("フリガナ", "furigana", "text", "メイジ タロウ", false)}
        {inp("氏名", "name", "text", "明治太郎", false)}
        {inp("生年月日", "dob", "date", "", false)}
        {/* {inp("チェックID", "checkId", "text", "", false)} */}
        <div className="field field-wide">
          {inp("勤務先・職名・学部・学年", "school", "text", "例：明治大学 情報コミュニケーション学部 3年", false)}
        </div>
        {inp("電話番号", "phone", "tel", "090-0000-0000", false)}
        {inp("郵便番号", "zip", "text", "000-0000", false)}
        <div className="field field-wide">
          {inp("住所", "address", "text", "", false)}
        </div>
      </div>

      <h3 className="subsection-title">口座情報（DBから取得）</h3>
      <div className="form-grid">
        {inp("銀行名", "bankName", "text", "例：三菱UFJ", false)}
        {inp("支店名", "branchName", "text", "", false)}
        {inp("支店番号", "branchNo", "text", "", false)}
        {inp("口座種別", "accountType", "text", "普通", false)}
        {inp("口座番号", "accountNo", "text", "", false)}
        <div className="field field-wide">
          {inp("口座名義（カナ）", "accountName", "text", "", false)}
        </div>
      </div>

      <div className="info-box" style={{ marginTop: 16 }}>
        <strong>🔗 SQL連携の実装方法</strong><br />
        <code>backend/src/routes/person.js</code> を追加し、<br />
        <code>GET /api/person/:id</code> → SQLからデータ取得 → JSON返却<br />
        フロントの <code>App.js</code> で <code>fetch("/api/person/" + id)</code> に差し替えるだけです。
      </div>
    </div>
  );
}
